/**
 * @generated SignedSource<<34b455a90f947c1439bf289a98131cf9>>
 * @relayHash 85c9f301275e04313c3ce4e453a8de66
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/549.0.0-2026-03-03T16:29:43.852Z/sbRespDesignsRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageDisplayEnum = "auctionsSearchAndBrowse" | "cart" | "catalog" | "checkout" | "email" | "favorites" | "homepage" | "mc" | "pdp" | "publication" | "searchAndBrowse" | "similarSold" | "visuallySimilar" | "%future added value";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type sbRespDesignsRootQuery$variables = {
  contentModuleId?: string | null;
  disableForceFacet?: boolean | null;
  disableNonParameterizedUrlRedirects?: boolean | null;
  fetchRegionalInfo?: boolean | null;
  fetchSb: boolean;
  fetchTileVideo?: boolean | null;
  fetchUser: boolean;
  first: number;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  guestId?: string | null;
  includeSponsoredItems?: boolean | null;
  isClient: boolean;
  isTrade: boolean;
  localeOrigin?: string | null;
  numOfItemsToInflate?: number | null;
  originalUrl?: string | null;
  page: number;
  pageDisplayEnum?: PageDisplayEnum | null;
  personalizationId?: string | null;
  priceBookName?: string | null;
  regions?: string | null;
  regionsList?: ReadonlyArray<string | null> | null;
  rerankGuestId?: string | null;
  rerankUserId?: string | null;
  showSeller: boolean;
  uriRef?: string | null;
  userCountryCode?: string | null;
  userId?: string | null;
  userZipCode?: string | null;
};
export type sbRespDesignsRootQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"SbRespDesignsLayout_viewer" | "detectPageExistsAndRedirect_viewer">;
  };
};
export type sbRespDesignsRootQuery = {
  response: sbRespDesignsRootQuery$data;
  variables: sbRespDesignsRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "contentModuleId"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "disableForceFacet"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "disableNonParameterizedUrlRedirects"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchSb"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchTileVideo"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchPages"
},
v9 = {
  "defaultValue": [
    "SEARCH",
    "USER_PREFERENCE"
  ],
  "kind": "LocalArgument",
  "name": "followSearchTypes"
},
v10 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "guestId"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSponsoredItems"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v14 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "localeOrigin"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numOfItemsToInflate"
},
v16 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "originalUrl"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v18 = {
  "defaultValue": "searchAndBrowse",
  "kind": "LocalArgument",
  "name": "pageDisplayEnum"
},
v19 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "personalizationId"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v21 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "regions"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionsList"
},
v23 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankGuestId"
},
v24 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankUserId"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showSeller"
},
v26 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "uriRef"
},
v27 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v28 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v29 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contemporaryTrackingString",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    (v30/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v41 = [
  (v40/*: any*/),
  (v35/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "Creator",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v41/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v46 = [
  (v44/*: any*/),
  (v45/*: any*/)
],
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": (v46/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v30/*: any*/),
                (v40/*: any*/),
                (v50/*: any*/),
                (v35/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v35/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "kind": "Literal",
  "name": "page",
  "value": "searchAndBrowse"
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    },
    (v53/*: any*/)
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v57 = [
  (v54/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "quantityDisplay",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentageOff",
    "storageKey": null
  },
  (v55/*: any*/),
  (v56/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showPriceLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showPriceVariability",
    "storageKey": null
  }
],
v58 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "isTrade",
      "value": false
    },
    (v52/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": (v57/*: any*/),
  "storageKey": "displayPrice(isTrade:false,page:\"searchAndBrowse\")"
},
v59 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewParagraph",
  "kind": "LinkedField",
  "name": "paragraphs",
  "plural": true,
  "selections": [
    (v60/*: any*/),
    (v61/*: any*/),
    {
      "alias": "mobileText",
      "args": (v59/*: any*/),
      "kind": "ScalarField",
      "name": "text",
      "storageKey": "text(formatType:\"MOBILE\")"
    }
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v40/*: any*/),
    (v47/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "style",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewCategorySegments",
  "kind": "LinkedField",
  "name": "paragraphAttributeNames",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "period",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "origin",
      "storageKey": null
    },
    (v64/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodPrefix",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        (v66/*: any*/)
      ],
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": [
        (v66/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplimentary",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCalculated",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "totalAmount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmounts",
      "kind": "LinkedField",
      "name": "convertedAmounts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "USD",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionName",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    (v69/*: any*/),
    (v70/*: any*/),
    (v71/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            (v72/*: any*/),
            (v35/*: any*/)
          ],
          "storageKey": null
        },
        (v35/*: any*/)
      ],
      "storageKey": null
    },
    (v35/*: any*/)
  ],
  "storageKey": null
},
v74 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallPath",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webPath",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v79 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v80 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v81 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v82 = [
  {
    "kind": "Variable",
    "name": "disableForceFacet",
    "variableName": "disableForceFacet"
  },
  {
    "kind": "Variable",
    "name": "disableNonParameterizedUrlRedirects",
    "variableName": "disableNonParameterizedUrlRedirects"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "guestId",
    "variableName": "guestId"
  },
  {
    "kind": "Variable",
    "name": "includeSponsoredItems",
    "variableName": "includeSponsoredItems"
  },
  {
    "kind": "Variable",
    "name": "localeOrigin",
    "variableName": "localeOrigin"
  },
  {
    "kind": "Variable",
    "name": "numOfItemsToInflate",
    "variableName": "numOfItemsToInflate"
  },
  {
    "kind": "Variable",
    "name": "originalUrl",
    "variableName": "originalUrl"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  (v79/*: any*/),
  {
    "kind": "Variable",
    "name": "regions",
    "variableName": "regions"
  },
  {
    "kind": "Variable",
    "name": "regionsList",
    "variableName": "regionsList"
  },
  (v80/*: any*/),
  (v81/*: any*/),
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "personalizationId"
  }
],
v83 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v84 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkReference",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchTerm",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mm",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "us",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hexCode",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedFilterName",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v96 = [
  (v76/*: any*/),
  (v75/*: any*/),
  (v77/*: any*/),
  (v35/*: any*/)
],
v97 = {
  "alias": "productPhotos",
  "args": (v74/*: any*/),
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": (v96/*: any*/),
  "storageKey": "photos(limit:1)"
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v42/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v99 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v100 = {
  "alias": null,
  "args": [
    (v99/*: any*/),
    (v52/*: any*/),
    (v79/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": (v57/*: any*/),
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    (v62/*: any*/),
    (v63/*: any*/),
    (v65/*: any*/)
  ],
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNewListing",
  "storageKey": null
},
v103 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 28
  }
],
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v105 = {
  "alias": "carouselPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 2
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": (v96/*: any*/),
  "storageKey": "photos(limit:2)"
},
v106 = {
  "condition": "showSeller",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerProfile",
          "kind": "LinkedField",
          "name": "sellerProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "company",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSold",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPartialItem",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personalizationType",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medianL3SoldItemPriceScore",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnHold",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnavailable",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccessible",
      "storageKey": null
    },
    (v35/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            (v93/*: any*/),
            (v35/*: any*/),
            (v72/*: any*/)
          ],
          "storageKey": null
        },
        (v35/*: any*/)
      ],
      "storageKey": null
    },
    (v35/*: any*/),
    (v69/*: any*/),
    (v70/*: any*/),
    (v71/*: any*/)
  ],
  "storageKey": null
},
v119 = {
  "alias": "displayPriceTracking",
  "args": [
    {
      "kind": "Literal",
      "name": "catchNonFatalErrors",
      "value": false
    },
    (v99/*: any*/),
    {
      "kind": "Variable",
      "name": "page",
      "variableName": "pageDisplayEnum"
    },
    (v79/*: any*/),
    (v81/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v54/*: any*/),
    (v56/*: any*/),
    (v55/*: any*/)
  ],
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "englishCountryName",
      "storageKey": null
    },
    (v35/*: any*/)
  ],
  "storageKey": null
},
v121 = {
  "alias": "productPhotos",
  "args": (v74/*: any*/),
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v75/*: any*/),
    (v77/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v122 = {
  "condition": "fetchTileVideo",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasApprovedVideo",
      "storageKey": null
    }
  ]
},
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "browsePageLinkData",
  "plural": false,
  "selections": (v46/*: any*/),
  "storageKey": null
},
v124 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v125 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v126 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "zipCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  },
  (v35/*: any*/)
],
v127 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sbRespDesignsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SbRespDesignsLayout_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "detectPageExistsAndRedirect_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v28/*: any*/),
      (v19/*: any*/),
      (v10/*: any*/),
      (v24/*: any*/),
      (v23/*: any*/),
      (v6/*: any*/),
      (v26/*: any*/),
      (v16/*: any*/),
      (v7/*: any*/),
      (v17/*: any*/),
      (v14/*: any*/),
      (v13/*: any*/),
      (v25/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v21/*: any*/),
      (v29/*: any*/),
      (v27/*: any*/),
      (v3/*: any*/),
      (v12/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v20/*: any*/),
      (v22/*: any*/),
      (v11/*: any*/),
      (v18/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Operation",
    "name": "sbRespDesignsRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "isWordpressArticlesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "WP_EDITORIAL"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 18
              },
              {
                "kind": "Literal",
                "name": "recentlyViewedIds",
                "value": []
              },
              {
                "kind": "Literal",
                "name": "returnAmount",
                "value": 12
              },
              {
                "kind": "Literal",
                "name": "userIds",
                "value": []
              }
            ],
            "concreteType": "Item",
            "kind": "LinkedField",
            "name": "recommendedItems",
            "plural": true,
            "selections": [
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "pdpMetaItems",
                "kind": "LinkedField",
                "name": "pdpMeta",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "topQuery",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v38/*: any*/),
              (v39/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemCreator",
                "kind": "LinkedField",
                "name": "creators",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "attribution",
                    "storageKey": null
                  },
                  (v42/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              (v43/*: any*/),
              (v47/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isStorefrontOnly",
                "storageKey": null
              },
              (v48/*: any*/),
              (v49/*: any*/),
              (v51/*: any*/),
              (v58/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "QuickViewDisplayType",
                "kind": "LinkedField",
                "name": "quickViewDisplay",
                "plural": false,
                "selections": [
                  (v32/*: any*/),
                  {
                    "alias": "mobileTitle",
                    "args": (v59/*: any*/),
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": "title(formatType:\"MOBILE\")"
                  },
                  (v62/*: any*/),
                  (v63/*: any*/),
                  (v65/*: any*/)
                ],
                "storageKey": null
              },
              (v67/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "address",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayCountry",
                    "storageKey": null
                  },
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              (v68/*: any*/),
              (v73/*: any*/),
              {
                "alias": "productPhotos",
                "args": (v74/*: any*/),
                "concreteType": "ItemPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                  (v75/*: any*/),
                  (v76/*: any*/),
                  (v77/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": "photos(limit:1)"
              },
              (v35/*: any*/)
            ],
            "storageKey": "recommendedItems(pageSize:18,recentlyViewedIds:[],returnAmount:12,userIds:[])"
          },
          {
            "alias": "video",
            "args": null,
            "concreteType": "VideoVimeo",
            "kind": "LinkedField",
            "name": "itemVideo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VideoVimeoFile",
                "kind": "LinkedField",
                "name": "fileByVideoSize",
                "plural": false,
                "selections": [
                  (v78/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v82/*: any*/),
            "concreteType": "ItemSearchQueryConnection",
            "kind": "LinkedField",
            "name": "itemSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pageExists",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unauthorized",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "redirectType",
                "kind": "LinkedField",
                "name": "redirect",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "location",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v35/*: any*/)
            ],
            "storageKey": null
          },
          (v35/*: any*/),
          {
            "condition": "isTrade",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "condition": "isClient",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      (v83/*: any*/),
                      (v80/*: any*/),
                      (v84/*: any*/)
                    ],
                    "concreteType": "ShippingFilterType",
                    "kind": "LinkedField",
                    "name": "shippingFilters",
                    "plural": true,
                    "selections": [
                      (v85/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v86/*: any*/),
                          (v87/*: any*/),
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "isTrade",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "address",
                        "value": {
                          "country": "us"
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "regionBoundaryTypes",
                        "value": [
                          "METROPOLITAN",
                          "DISTRICT",
                          "DOMESTIC"
                        ]
                      },
                      {
                        "kind": "Literal",
                        "name": "regionType",
                        "value": "ITEM_LOCATION"
                      }
                    ],
                    "concreteType": "Region",
                    "kind": "LinkedField",
                    "name": "regions",
                    "plural": true,
                    "selections": [
                      (v72/*: any*/),
                      (v87/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RegionBoundary",
                        "kind": "LinkedField",
                        "name": "regionBoundary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RegionBoundaryType",
                            "kind": "LinkedField",
                            "name": "type",
                            "plural": false,
                            "selections": [
                              (v85/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v35/*: any*/)
                    ],
                    "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "locations",
                "args": [
                  (v83/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "facetLimit",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "facetName",
                    "value": "location"
                  },
                  (v80/*: any*/),
                  (v84/*: any*/)
                ],
                "concreteType": "ItemFacetsQueryConnection",
                "kind": "LinkedField",
                "name": "itemFacetSearch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemFacetsQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v88/*: any*/),
                          (v40/*: any*/),
                          (v87/*: any*/),
                          (v86/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "guestId",
                    "variableName": "rerankGuestId"
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "rerankUserId"
                  }
                ],
                "kind": "ScalarField",
                "name": "isEligibleForRerank",
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v83/*: any*/),
                  (v84/*: any*/)
                ],
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "kind": "LinkedField",
                    "name": "regionsByZipCode",
                    "plural": true,
                    "selections": [
                      (v40/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v35/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchSb",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v82/*: any*/),
                "concreteType": "ItemSearchQueryConnection",
                "kind": "LinkedField",
                "name": "itemSearch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchCorrectionsType",
                    "kind": "LinkedField",
                    "name": "searchCorrections",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "classificationSearchTerm",
                        "storageKey": null
                      },
                      (v89/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "semanticSearchTerm",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "forceSearchUri",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "originalSearchTerm",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchCorrectionSuggestionsValues",
                        "kind": "LinkedField",
                        "name": "suggestions",
                        "plural": true,
                        "selections": [
                          (v85/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uri",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "searchType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParam",
                    "kind": "LinkedField",
                    "name": "appliedFilters",
                    "plural": true,
                    "selections": [
                      (v85/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v87/*: any*/),
                          (v40/*: any*/),
                          (v86/*: any*/),
                          (v88/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FilterPropertiesType",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                              (v90/*: any*/),
                              (v91/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v92/*: any*/),
                          (v93/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canBeDismissed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clearAllLinkReference",
                        "storageKey": null
                      },
                      (v94/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vanityUriRef",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayUriRef",
                    "storageKey": null
                  },
                  (v95/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pageType",
                    "storageKey": null
                  },
                  (v89/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "isRewarded",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "listNames",
                            "value": [
                              "SELLER_REWARDS_1",
                              "SELLER_REWARDS_2"
                            ]
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "isAnchorListsMember",
                        "storageKey": "isAnchorListsMember(listNames:[\"SELLER_REWARDS_1\",\"SELLER_REWARDS_2\"])"
                      },
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v61/*: any*/),
                      (v44/*: any*/),
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                      }
                    ],
                    "concreteType": "youMayAlsoLikeConnection",
                    "kind": "LinkedField",
                    "name": "youMayAlsoLike",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "youMayAlsoLikeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  (v37/*: any*/),
                                  (v97/*: any*/),
                                  (v38/*: any*/),
                                  (v67/*: any*/),
                                  (v43/*: any*/),
                                  (v32/*: any*/),
                                  (v39/*: any*/),
                                  (v98/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v51/*: any*/),
                                  (v100/*: any*/),
                                  (v68/*: any*/),
                                  (v73/*: any*/),
                                  (v101/*: any*/),
                                  (v102/*: any*/),
                                  (v31/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v36/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "youMayAlsoLike(first:20)"
                  },
                  {
                    "alias": "soldItems",
                    "args": (v103/*: any*/),
                    "concreteType": "soldResultsConnection",
                    "kind": "LinkedField",
                    "name": "soldResults",
                    "plural": false,
                    "selections": [
                      (v95/*: any*/)
                    ],
                    "storageKey": "soldResults(first:28)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MetaData",
                    "kind": "LinkedField",
                    "name": "meta",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "header",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subHeader",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "prev",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "disableIndexing",
                        "storageKey": null
                      },
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "topQueries",
                        "storageKey": null
                      },
                      (v104/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canonical",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "next",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LanguageAnnotations",
                        "kind": "LinkedField",
                        "name": "languageAnnotations",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "href",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hrefLang",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "microdata",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "soldItemResults",
                    "args": (v103/*: any*/),
                    "concreteType": "soldResultsConnection",
                    "kind": "LinkedField",
                    "name": "soldResults",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "soldResultsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  (v97/*: any*/),
                                  (v38/*: any*/),
                                  (v67/*: any*/),
                                  (v43/*: any*/),
                                  (v32/*: any*/),
                                  (v39/*: any*/),
                                  (v98/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v51/*: any*/),
                                  {
                                    "alias": null,
                                    "args": [
                                      (v99/*: any*/),
                                      (v52/*: any*/)
                                    ],
                                    "concreteType": "ItemDisplayPriceType",
                                    "kind": "LinkedField",
                                    "name": "displayPrice",
                                    "plural": true,
                                    "selections": (v57/*: any*/),
                                    "storageKey": null
                                  },
                                  (v68/*: any*/),
                                  (v73/*: any*/),
                                  (v101/*: any*/),
                                  (v102/*: any*/),
                                  (v37/*: any*/),
                                  (v105/*: any*/),
                                  (v31/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v36/*: any*/),
                                  (v35/*: any*/),
                                  (v106/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "soldResults(first:28)"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "contentModuleId",
                        "variableName": "contentModuleId"
                      }
                    ],
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "browseContentModule",
                    "plural": false,
                    "selections": [
                      (v107/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BrowseContentModuleBannerType",
                            "kind": "LinkedField",
                            "name": "banners",
                            "plural": true,
                            "selections": [
                              (v107/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ContentModuleBannerTiles",
                        "abstractKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "moduleType",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorytellingModuleItem",
                            "kind": "LinkedField",
                            "name": "storytellingModules",
                            "plural": true,
                            "selections": [
                              (v50/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "headerText",
                                "storageKey": null
                              },
                              (v104/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "footnoteText",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "backgroundColor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textColor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "includeItem",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ctaText",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ctaLink",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "ctaType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "size",
                                        "value": "small"
                                      }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "firstPhotoWebPath",
                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                  },
                                  (v32/*: any*/),
                                  (v38/*: any*/),
                                  (v58/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ContentModuleStorytelling",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainImage",
                            "storageKey": null
                          },
                          (v32/*: any*/),
                          (v104/*: any*/)
                        ],
                        "type": "ContentModuleIconicDesign",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseCategoryTiles",
                    "kind": "LinkedField",
                    "name": "categoryTiles",
                    "plural": true,
                    "selections": [
                      (v40/*: any*/),
                      (v108/*: any*/),
                      (v109/*: any*/),
                      (v110/*: any*/),
                      (v107/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isL1LandingPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayMaxNumberOfPages",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilter",
                    "kind": "LinkedField",
                    "name": "filters",
                    "plural": true,
                    "selections": [
                      (v85/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseFilterValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v86/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkable",
                            "storageKey": null
                          },
                          (v40/*: any*/),
                          (v87/*: any*/),
                          (v53/*: any*/),
                          (v88/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "stats",
                            "kind": "LinkedField",
                            "name": "stats",
                            "plural": true,
                            "selections": [
                              (v60/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "values",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v92/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FilterPropertiesType",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                              (v90/*: any*/),
                              (v91/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "min",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "max",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v93/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v94/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "originalFilterName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "topCategoryL1",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAttributePage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SortType",
                    "kind": "LinkedField",
                    "name": "sort",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortAvailableOptions",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          (v87/*: any*/),
                          (v86/*: any*/),
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortCurrentOption",
                        "kind": "LinkedField",
                        "name": "currentOption",
                        "plural": false,
                        "selections": [
                          (v87/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "searchRequestId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchSponsored",
                    "kind": "LinkedField",
                    "name": "sponsored",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxAvailable",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSearchSponsoredMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": true,
                        "selections": [
                          (v108/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "impressionTrackerLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "clickTrackerLink",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v30/*: any*/),
                          (v111/*: any*/),
                          (v112/*: any*/),
                          (v113/*: any*/),
                          (v114/*: any*/),
                          (v37/*: any*/),
                          (v115/*: any*/),
                          (v116/*: any*/),
                          (v117/*: any*/),
                          (v118/*: any*/),
                          (v32/*: any*/),
                          (v119/*: any*/),
                          (v120/*: any*/),
                          (v34/*: any*/),
                          (v33/*: any*/),
                          (v31/*: any*/),
                          (v102/*: any*/),
                          (v68/*: any*/),
                          (v38/*: any*/),
                          (v67/*: any*/),
                          (v43/*: any*/),
                          (v39/*: any*/),
                          (v98/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v51/*: any*/),
                          (v100/*: any*/),
                          (v101/*: any*/),
                          (v105/*: any*/),
                          (v121/*: any*/),
                          (v35/*: any*/),
                          (v106/*: any*/),
                          (v122/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSearchResult",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              (v30/*: any*/),
                              (v111/*: any*/),
                              (v112/*: any*/),
                              (v113/*: any*/),
                              (v114/*: any*/),
                              (v37/*: any*/),
                              (v115/*: any*/),
                              (v116/*: any*/),
                              (v117/*: any*/),
                              (v118/*: any*/),
                              (v32/*: any*/),
                              (v119/*: any*/),
                              (v120/*: any*/),
                              (v34/*: any*/),
                              (v33/*: any*/),
                              (v31/*: any*/),
                              (v102/*: any*/),
                              (v68/*: any*/),
                              (v38/*: any*/),
                              (v67/*: any*/),
                              (v43/*: any*/),
                              (v39/*: any*/),
                              (v98/*: any*/),
                              (v47/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v51/*: any*/),
                              (v100/*: any*/),
                              (v101/*: any*/),
                              (v105/*: any*/),
                              (v121/*: any*/),
                              (v35/*: any*/),
                              {
                                "alias": null,
                                "args": (v74/*: any*/),
                                "concreteType": "ItemPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                  (v77/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": "photos(limit:1)"
                              },
                              (v106/*: any*/),
                              (v122/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "relatedItems",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 12
                      }
                    ],
                    "concreteType": "youMayAlsoLikeConnection",
                    "kind": "LinkedField",
                    "name": "youMayAlsoLike",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "youMayAlsoLikeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  (v38/*: any*/),
                                  (v67/*: any*/),
                                  (v43/*: any*/),
                                  (v32/*: any*/),
                                  (v39/*: any*/),
                                  (v98/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v51/*: any*/),
                                  (v100/*: any*/),
                                  (v68/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ShipmentQuote",
                                    "kind": "LinkedField",
                                    "name": "shipmentQuotes",
                                    "plural": true,
                                    "selections": [
                                      (v69/*: any*/),
                                      (v70/*: any*/),
                                      (v71/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ShipmentServiceMethod",
                                        "kind": "LinkedField",
                                        "name": "serviceMethod",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Region",
                                            "kind": "LinkedField",
                                            "name": "region",
                                            "plural": false,
                                            "selections": [
                                              (v72/*: any*/),
                                              (v35/*: any*/),
                                              (v93/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v35/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v35/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v101/*: any*/),
                                  (v105/*: any*/),
                                  (v102/*: any*/),
                                  (v37/*: any*/),
                                  (v121/*: any*/),
                                  (v115/*: any*/),
                                  (v111/*: any*/),
                                  (v116/*: any*/),
                                  (v117/*: any*/),
                                  (v119/*: any*/),
                                  (v120/*: any*/),
                                  (v114/*: any*/),
                                  (v34/*: any*/),
                                  (v33/*: any*/),
                                  (v31/*: any*/),
                                  (v113/*: any*/),
                                  (v35/*: any*/),
                                  (v106/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "youMayAlsoLike(first:12)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "soldResultsConnection",
                    "kind": "LinkedField",
                    "name": "soldResults",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "soldResultsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  (v32/*: any*/),
                                  (v36/*: any*/),
                                  (v119/*: any*/),
                                  (v120/*: any*/),
                                  (v114/*: any*/),
                                  (v34/*: any*/),
                                  (v33/*: any*/),
                                  (v31/*: any*/),
                                  (v102/*: any*/),
                                  (v113/*: any*/),
                                  (v68/*: any*/),
                                  (v73/*: any*/),
                                  (v38/*: any*/),
                                  (v67/*: any*/),
                                  (v43/*: any*/),
                                  (v39/*: any*/),
                                  (v98/*: any*/),
                                  (v47/*: any*/),
                                  (v48/*: any*/),
                                  (v49/*: any*/),
                                  (v51/*: any*/),
                                  (v100/*: any*/),
                                  (v101/*: any*/),
                                  (v105/*: any*/),
                                  (v37/*: any*/),
                                  (v121/*: any*/),
                                  (v35/*: any*/),
                                  (v106/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clearAppliedFiltersLinkReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canFollowSearch",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 8
                      }
                    ],
                    "concreteType": "WordpressArticlesType",
                    "kind": "LinkedField",
                    "name": "editorialArticles",
                    "plural": false,
                    "selections": [
                      (v95/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WordpressArticleType",
                        "kind": "LinkedField",
                        "name": "articles",
                        "plural": true,
                        "selections": [
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WordpressArticleImageType",
                            "kind": "LinkedField",
                            "name": "imageUrl",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "full",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subtitle",
                            "storageKey": null
                          },
                          (v78/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "source",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "editorialArticles(first:8)"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "maxCreatorDesigns",
                        "value": 5
                      },
                      {
                        "kind": "Literal",
                        "name": "maxSiblingDesigns",
                        "value": 4
                      }
                    ],
                    "concreteType": "DesignPageInfo",
                    "kind": "LinkedField",
                    "name": "designPageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IconicDesign",
                        "kind": "LinkedField",
                        "name": "design",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Creator",
                            "kind": "LinkedField",
                            "name": "creators",
                            "plural": true,
                            "selections": [
                              (v40/*: any*/),
                              (v85/*: any*/),
                              (v123/*: any*/),
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v35/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IconicDesign",
                            "kind": "LinkedField",
                            "name": "parent",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/),
                              (v123/*: any*/),
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IconicDesign",
                        "kind": "LinkedField",
                        "name": "siblingDesigns",
                        "plural": true,
                        "selections": [
                          (v40/*: any*/),
                          (v87/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "browsePageImage",
                            "storageKey": null
                          },
                          (v123/*: any*/),
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Creator",
                        "kind": "LinkedField",
                        "name": "primaryCreator",
                        "plural": false,
                        "selections": (v41/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CreatorDesigns",
                        "kind": "LinkedField",
                        "name": "creatorDesigns",
                        "plural": true,
                        "selections": [
                          (v109/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LinkData",
                            "kind": "LinkedField",
                            "name": "browsePageLinkData",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/),
                              (v44/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v40/*: any*/),
                          (v50/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              (v80/*: any*/)
                            ],
                            "concreteType": "QuickViewDisplayType",
                            "kind": "LinkedField",
                            "name": "quickViewDisplay",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              (v47/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuickViewParagraph",
                                "kind": "LinkedField",
                                "name": "paragraphs",
                                "plural": true,
                                "selections": [
                                  (v60/*: any*/),
                                  (v61/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuickViewCategorySegments",
                                "kind": "LinkedField",
                                "name": "paragraphAttributeNames",
                                "plural": false,
                                "selections": [
                                  (v64/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "material",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "kind": "LinkedField",
                                    "name": "averagePrice",
                                    "plural": false,
                                    "selections": [
                                      (v54/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "numAvailable",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v63/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "designPageInfo(maxCreatorDesigns:5,maxSiblingDesigns:4)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appliedPersonalizationList",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbTestConfigV2UserVariant",
                    "kind": "LinkedField",
                    "name": "seoAbTestV2List",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "variant",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbTestConfigV2",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "testName",
                            "storageKey": null
                          },
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trackedAbTests",
                    "storageKey": null
                  },
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          (v99/*: any*/)
                        ],
                        "concreteType": "SearchBrowsePriceTile",
                        "kind": "LinkedField",
                        "name": "priceTiles",
                        "plural": true,
                        "selections": [
                          (v53/*: any*/),
                          (v40/*: any*/),
                          (v110/*: any*/),
                          (v109/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseFacets",
                        "kind": "LinkedField",
                        "name": "facets",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacetValueType",
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": true,
                            "selections": [
                              (v85/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v124/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  (v107/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "kind": "LinkedField",
                    "name": "tradeFirm",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "rewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "kind": "LinkedField",
                            "name": "currentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "kind": "LinkedField",
                                "name": "programInfo",
                                "plural": false,
                                "selections": [
                                  (v93/*: any*/),
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v125/*: any*/),
                          (v93/*: any*/),
                          (v35/*: any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v124/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v93/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v35/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v125/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowFolder",
                    "storageKey": null
                  },
                  {
                    "condition": "showSeller",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canShowSellerName",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "alias": "hasMerchandizingPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "BUYER_FE_MERCH_TOOL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                  },
                  {
                    "alias": "canShowStorefrontOnlyBadge",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "VIEW_STOREFRONT_ONLY_BADGE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "measurementUnit",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "kind": "LinkedField",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "personalAddress",
                        "plural": false,
                        "selections": (v126/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "proAddress",
                        "plural": false,
                        "selections": (v126/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "addressList",
                        "plural": true,
                        "selections": (v126/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "showStrategicPartnerFilter",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "STRATEGIC_PARTNER_FILTERING"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"STRATEGIC_PARTNER_FILTERING\")"
                  },
                  {
                    "alias": "hasBasicInternalPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "BASIC_INTERNAL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"BASIC_INTERNAL\")"
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v127/*: any*/),
                        "concreteType": "favoritesConnection",
                        "kind": "LinkedField",
                        "name": "favorites",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "favoritesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Favorite",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  (v40/*: any*/),
                                  (v35/*: any*/),
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__id",
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  (v107/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v127/*: any*/),
                        "filters": [],
                        "handle": "connection",
                        "key": "SharedSaveSearchContext_favorites",
                        "kind": "LinkedHandle",
                        "name": "favorites"
                      }
                    ]
                  },
                  (v35/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/549.0.0-2026-03-03T16:29:43.852Z/sbRespDesignsRootQuery",
    "metadata": {},
    "name": "sbRespDesignsRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "285d4abbbc9aee0d76e1816f1baa648e";

export default node;
